import React from 'react';

import cn from 'classnames';

import s from './mc.module.scss';

/**
 * MCToggle — accessible brand switch. Drop-in replacement for the existing
 * notification toggles: the caller owns the state and passes `checked` +
 * `onChange`. This component never holds state of its own.
 *
 * onChange is invoked with the NEXT boolean value: onChange(!checked).
 *
 * @param {boolean} checked
 * @param {(next: boolean) => void} onChange
 * @param {boolean} [disabled]
 * @param {React.ReactNode} [label]
 */
const MCToggle = ({ checked = false, onChange, disabled = false, label, className, ...rest }) => {
  const toggle = () => {
    if (disabled) return;
    if (typeof onChange === 'function') onChange(!checked);
  };

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      toggle();
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={typeof label === 'string' ? label : undefined}
      disabled={disabled}
      onClick={toggle}
      onKeyDown={handleKeyDown}
      className={cn(s.toggle, { [s.toggleOn]: checked }, className)}
      {...rest}>
      <span className={s.toggleTrack} aria-hidden="true">
        <span className={s.toggleThumb} />
      </span>
      {label != null && <span className={s.toggleLabel}>{label}</span>}
    </button>
  );
};

export default MCToggle;
